import { render, staticRenderFns } from "./performanceStatistics.vue?vue&type=template&id=1d2fd27c&scoped=true&"
import script from "./performanceStatistics.vue?vue&type=script&lang=js&"
export * from "./performanceStatistics.vue?vue&type=script&lang=js&"
import style0 from "./performanceStatistics.vue?vue&type=style&index=0&id=1d2fd27c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2fd27c",
  null
  
)

export default component.exports